import queryString from 'query-string'
import { capitalizer, pluralizer } from '../../../../helpers/URL'
import { dispensaryService, productService } from '../../../../services'
import dynamic from 'next/dynamic';
import { serverLocationDetector } from '../../../../utils/locationDetector';
import sorts from '../../../../config/sorts';
import { useEffect, useState } from 'react';
const Layout = dynamic(() => import('../../../../components/_App/Layout'))
const BusinessMenu = dynamic(() => import('../../../../templates/BusinessMenu'))


export default function DispensaryMenuLayout({products, entity, preloadedFilters, isAppleMobile}){


    const [ brandFilterItems, setBrandFilterItems ] = useState([])
    const [ loadingBrands, setLoadingBrands ] = useState(true)
    const [ loadedAllBrands, setLoadedAllBrands ] = useState(false)

    const getBrandFilters = async (all, search) => {
        try {
            setLoadingBrands(true)
            const response = await productService.getFilter(
                entity.slug, 
                `?${all ? 'all=true&' : ''}`+`${search ? 'searchBrand='+search+'&' : ''}`, 
                'brands'
            )
            setBrandFilterItems(response.totalData)
            all && setLoadedAllBrands(true)
            setLoadingBrands(false)
        } catch (er) {
            console.log(er)
        }
    }

    useEffect(() => {
        getBrandFilters()
    }, [])
  
    return (
        <Layout
            isAppleMobile = { isAppleMobile }
            seo={{
                description: '',
                image: entity.logo ? entity.logo : '/static/icons/favicon.png',
                title: entity.name+" Menu - "+capitalizer(entity.type)+" in "+entity.city.name+" | Weedzly",
                url: `https://weedzly.com/${pluralizer(entity.type.toLowerCase())}/${entity.slug}/menu`
            }}
        >
            <BusinessMenu 
                products={products}
                entity={entity}
                preloadedFilters={preloadedFilters}
                asyncFilters = {[
                    {
                        label: 'Brands',
                        filterfield: 'brand', 
                        field: 'brand',
                        items: brandFilterItems,
                        loading: loadingBrands,
                        icon: 'tag',
                        type: 'eq',
                        loadedAllBrands: loadedAllBrands,
                        multi:true,
                        searchEnabled:true,
                        getAll: (all, search)=>getBrandFilters(all, search)
                    }
                ]}
            />
        </Layout>
    )
}

export async function getServerSideProps(context){

    let isAppleMobile = (context.req
        ? context.req.headers['user-agent']
        : navigator.userAgent).match(
          /iPhone|iPad|iPod/i
        )

    await serverLocationDetector(context)

    let dispensarySlug = context.query.slug

    if(!context.query.sortField && !context.query.sortOrder){
        let defatultSort = sorts.dispensaryMenuPage[0].opts.find(x => x.default)
        context.query.sortField = defatultSort.sortField
        context.query.sortOrder =  defatultSort.sortOrder
    }

    let contextQuery = queryString.parse(queryString.stringify(context.query), {arrayFormat:'bracket'})
    delete contextQuery.slug

    let newQuery = Object.assign({page:1, size:24}, contextQuery)

    const [ products, entity, variants ] = await Promise.all([
        productService.getAll(
            dispensarySlug,
            `?${queryString.stringify(newQuery, {arrayFormat:'bracket'})}`,
        ),
        dispensaryService.getDetailsPage(dispensarySlug), 
        productService.getVariantFilter(dispensarySlug)
    ])

    return {
        props: {
            isAppleMobile,
            products, 
            entity, 
            contextQuery: contextQuery,
            preloadedFilters:{
                weight: variants
            },
        }
    } 
}
